import { Component } from '@angular/core';

/**
 * Generated class for the RcsKdProductSearchComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'rcs-kd-product-search',
  templateUrl: 'rcs-kd-product-search.html'
})
export class RcsKdProductSearchComponent {

  text: string;

  constructor() {
    console.log('Hello RcsKdProductSearchComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-product-search/rcs-kd-product-search.ts